<div class="container">
    <div class="row align-items-center justify-content-between">

        <!-- Legenda custom a sinistra -->
        <div class="col-md-4 d-flex flex-column align-items-center justify-content-center">
            <ul class="list-unstyled">
                @if (loading()) {
                @for (elem of [1,2,3]; track $index) {
                <li class="d-flex align-items-center mb-2 placeholder-glow">
                    <span class="me-2 d-inline-block donut-legend-box placeholder"></span>
                    <span class="placeholder" style="width: 200px;"></span>
                </li>
                }
                } @else {
                @for (segment of segments(); track $index) {
                <li class="d-flex align-items-center mb-2">
                    <span class="me-2 d-inline-block donut-legend-box" [style.backgroundColor]="segment.color"></span>
                    {{ segment.label }}
                    <span class="ms-2 text-muted">
                        ({{ totalValue() > 0 ? ((segment.value / totalValue()) * 100).toFixed() : 0 }}%)
                    </span>
                </li>
                }
                }
            </ul>
        </div>

        <!-- Grafico a destra -->
        <div class="col-md-8">
            <div>
                <canvas #donutCanvas style="width: 100%; height: 200px; position: relative; top: -20px;"></canvas>
            </div>
        </div>

    </div>
</div>